import { connect } from 'react-redux';
import CareGuidePartnerTagsAdminScreen from '../components/CareGuidePartnerTagsAdminScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    total: state.careGuidePartnerTagsAdmin.get('total'),
    isLoading: state.careGuidePartnerTagsAdmin.get('isLoading'),
    activeId: storage.get(findStorageType(), 'partnershipId'),
    access_role_admin_in_app: storage.get(findStorageType(), 'partnershipData')
      ?.access_role_admin_in_app,
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const CareGuidePartnerTagsAdminScreenContainer = connect(mapStateToProps)(
  CareGuidePartnerTagsAdminScreen
);

export default CareGuidePartnerTagsAdminScreenContainer;
